import typeaheadMatchTemplate from 'text!./templates/typeahead-match.html';

export default [function () {
    return {
        scope: {
            index: '=',
            match: '=',
            query: '=',
            selectDirective: '='
        },
        template: typeaheadMatchTemplate
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/typeahead/Match.js
// module id = 2055
// module chunks = 0